export default function Index() {
  return 'Error 404';
}
